import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import IconWarning from "../Resources/svg/Icons/IconWarning";
import { modalError } from "../Store/simulate/actions";
import Button from "./FormElements/Button";

interface Props {
  className?: string;
  title: string;
  text?: string;
}

const ModalInformative = ({ className, title, text }: Props) => {
  const history = useHistory();

  const [isOpen, setIsOpen] = useState(false);
  const dispatch = useDispatch();
  const { modalError: modalErrorState } = useSelector(
    (state: any) => state.simulate.policy
  );

  const handleClose = () => {
    setIsOpen(false);
    dispatch(modalError(false));
    document.body.style.overflow = "auto";
  };

  const handleOpen = () => {
    setIsOpen(true);
    document.body.style.overflow = "hidden";
  };

  useEffect(() => {
    if (modalErrorState) {
      handleOpen();
    } else {
      handleClose();
    }
  }, [modalErrorState]);

  const handleErrorModal = () => {
    setIsOpen(false);
    dispatch(modalError(false));
    document.body.style.overflow = "auto";

    if (text === "1") {
      history.push("/perfil-de-inversion");
    } else {
      history.push("/simulaciones");
    }
  };

  return (
    <div
      className={
        "modal-filtering modal-result is-midle-error" +
        (isOpen ? " is-open" : "") +
        (className ? " " + className : "")
      }
    >
      <div className={"modal-filtering__box"}>
        <div className="modal-filtering__body">
          <div className="wrap">
            <div className="modal-filtering__inner">
              <div className="modal-result__icon--warning">
                <IconWarning />
              </div>
              <h2 className="modal-result__title">{title}</h2>
              <div className="modal-result__desc">
                {text === "1" ? (
                  <>
                    Estimado asesor, para un correcto funcionamiento de la
                    emisión en línea, se solicita enviar un correo al buzón{" "}
                    <span>verificaciondedatos@rimac.com.pe</span> indicando el
                    DNI, dirección y fecha de nacimiento del cliente ya que aún
                    no se encuentra creado dentro de la Base de Datos de Rimac
                  </>
                ) : (
                  <>
                    Estimado asesor, para un correcto funcionamiento de la
                    emisión en línea, se solicita enviar un correo al buzón{" "}
                    <span>verificaciondedatos@rimac.com.pe</span> indicando el
                    DNI, dirección y fecha de nacimiento del cliente. En caso de
                    haber realizado el proceso y recibir la conformidad del
                    registro, volver a intentarlo en unos minutos.​
                  </>
                )}
              </div>
              <div className="actions">
                <Button
                  className="actions__continue"
                  onClick={handleErrorModal}
                >
                  Entendido
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalInformative;
